import type { PropsWithChildren } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LogtoProvider } from './auth/LogtoProvider';
import { Book } from './pages/Book';
import { Callback } from './pages/Callback';
import { Customers } from './pages/Customers';
import { Dashboard } from './pages/Dashboard';
import { Home } from './pages/Home';
import { Manifest } from './pages/Manifest';
import { Requests } from './pages/Requests';
import { Tours } from './pages/Tours';
import { Layout } from './ui/Layout';
import { RequireAuth } from './ui/RequireAuth';

function Protected({ children }: PropsWithChildren) {
  return (
    <RequireAuth>
      <Layout>{children}</Layout>
    </RequireAuth>
  );
}

export function App() {
  return (
    <LogtoProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/callback" element={<Callback />} />
          <Route path="/" element={<Protected><Home /></Protected>} />
          <Route path="/tours" element={<Protected><Tours /></Protected>} />
          <Route path="/book" element={<Protected><Book /></Protected>} />
          <Route path="/manifest" element={<Protected><Manifest /></Protected>} />
          <Route path="/requests" element={<Protected><Requests /></Protected>} />
          <Route path="/customers" element={<Protected><Customers /></Protected>} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        </Routes>
      </BrowserRouter>
    </LogtoProvider>
  );
}
